// extracted by mini-css-extract-plugin
export default {"dashboard":"TableauDeBord_dashboard__4YVJl","content":"TableauDeBord_content__QBfjF","logoutButton":"TableauDeBord_logoutButton__-MOl-"};